import React, { useState } from 'react';
import { Modal, Input, Alert, message, Space } from 'antd';
import { marcarFallida } from '../../api/brevoSyncApi';

interface MarcarFallidaModalProps {
  visible: boolean;
  executionId: number | null;
  onClose: () => void;
  onMarked: () => void;
}

const MarcarFallidaModal: React.FC<MarcarFallidaModalProps> = ({ visible, executionId, onClose, onMarked }) => {
  const [motivo, setMotivo] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleOk = async () => {
    if (!executionId || !motivo.trim()) return;
    setSubmitting(true);
    try {
      await marcarFallida(executionId, motivo.trim());
      message.success('Ejecución marcada como fallida');
      setMotivo('');
      onMarked();
      onClose();
    } catch (error: any) {
      if (error?.response?.status === 404) {
        message.error('La ejecución no existe o ya no está en curso');
      } else {
        message.error('Error al marcar la ejecución como fallida');
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setMotivo('');
    onClose();
  };

  return (
    <Modal
      open={visible}
      title="Marcar ejecución como fallida"
      okText="Marcar como fallida"
      cancelText="Cancelar"
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={submitting}
      okButtonProps={{ danger: true, disabled: !motivo.trim() }}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Alert
          type="warning"
          showIcon
          message="Esta acción NO matará el proceso Python"
          description="Solo cambiará el estado en la base de datos para liberar el lock y poder lanzar otra ejecución. Si el proceso sigue corriendo en 10.0.1.132, deberás verificarlo y matarlo manualmente."
        />
        <Input.TextArea
          value={motivo}
          onChange={e => setMotivo(e.target.value)}
          placeholder="Motivo, ej: Proceso colgado sin progreso desde hace 15 min"
          rows={3}
        />
      </Space>
    </Modal>
  );
};

export default MarcarFallidaModal;
